module.exports = {"en-US":{"table-header":{"actions":"Actions"}}}